import React from 'react';
import { useDropzone } from 'react-dropzone';
import { isArrayLength } from '../../util/genericHelpers';
import Icons from '../Icons/Icons';
import { showErrorToast } from '../../util/toast';

const maxSize = 20 * 1024 * 1024; // 20MB in bytes

function DropZone(props) {
  const { onAttachmentUpload, acceptedTypes, className } = props;

  const onTriggerError = () => {
    showErrorToast('The maximum file size is 20 MB. Please try again.');
  };

  const onDrop = (acceptedFiles, rejectedFiles) => {
    // Handling accepted files
    if (isArrayLength(acceptedFiles))
      acceptedFiles.forEach(file => {
        onAttachmentUpload(file);
      });

    // Handling rejected files (e.g., files that exceed the size limit)
    if (isArrayLength(rejectedFiles)) {
      onTriggerError();
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: acceptedTypes,

    maxSize: maxSize,
    onDrop,
  });

  return (
    <div {...getRootProps({ className: 'dropzone', className })}>
      <input {...getInputProps()} />
      <Icons name="camera" />
    </div>
  );
}
export default DropZone;
